import Button from '@material-ui/core/Button'
import React from 'react'
import VideoModal from './VideoModal'
import PropTypes from 'proptypes'
import styled, { keyframes } from 'styled-components'
import PlayButton from '../../images/icons/play-button.svg'

const pulse = keyframes`
0% {
  transform: scale(1);
  border-color: rgba(255,255,255,.55)
}

100% {
  transform: scale(1.17);
  border-color: rgba(255,255,255,0)
}
`

const PlayPulse = styled('div')`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  border: 5px solid rgba(255, 255, 255, 1);
  animation-name: ${pulse};
  animation-duration: 3.2s;
  animation-timing-function: ease-out;
  animation-iteration-count: infinite;
  animation-play-state: running;
  height: inherit;
  width: inherit;
  border-radius: 50%;
`
const VideoButton = styled(Button)`
  position: absolute !important;
  top: 50%;
  left: 50%;
  height: ${(props) => (props.tablet || props.watch ? '6.5rem' : '5rem')};
  width: ${(props) => (props.tablet || props.watch ? '6.5rem' : '5rem')};
  background-color: ${(props) => (props.consumer ? 'transparent' : '#fff')};
  border-radius: 50%;
  display: inline-flex;
  margin: auto;
  transform: translate(-50%, -50%) scale(1);
  transition: all 0.5s ease-in;
  color: inherit;
  cursor: pointer;
  &:hover {
    color: inherit;
    transform: translate(-50%, -50%) scale(1.1);
    background-color: ${(props) => (props.consumer ? 'transparent' : '#fff')};
  }
  img {
    padding: ${(props) => (props.consumer ? '0' : '2px')};
  }
`
function VideoPulseButton(props) {
  return (
    <>
      <VideoModal videoUrl={props.videoUrl}>
        <VideoButton tablet={props.tablet} consumer={props.consumer} watch={props.watch}>
          <PlayPulse>
            <img placeholder="none" src={PlayButton} />
          </PlayPulse>
        </VideoButton>
      </VideoModal>
    </>
  )
}

export default VideoPulseButton

VideoPulseButton.propTypes = {
  videoUrl: PropTypes.string
}
